<template>
  <div style="background-color: #fff;">
    
    <HeaderM :isMain="false"/>
    <Header/>
    
    <Nav :list="headerList"/>
    <SingleBanner/>
    <div class="current-page-content" style="padding: 30px 0 17px 0;">
        
      <div class="search-input-blo">
        <div class="title">招生机构核验查询</div>
        <div class="subtitle">输入查询条件，查询满足条件的数据。</div>
        <div class="desc-con">
          <div class="label">单位名称：</div>
          <el-input v-model="name" placeholder="请输入搜索的内容" class="s-input"></el-input>
          <div class="search-btn" @click="searchHandle">
            <i style="font-size: 20px;" class="el-icon-search"></i>
            查询
          </div>
        </div>
      </div>   
      <div v-if="jigouList.length > 0" class="en-table">
        <div class="common-row en-header">
          <div class="header-col1">合作方机构</div>
          <div class="header-col2">合作区域</div>
          <div class="header-col3">联系电话</div>
          <div class="header-col4">联系地址</div>
          <div class="header-col5">合作有效期</div>
        </div>
        <div v-for="item in jigouList" :key="item.id" class="common-row en-row">
          <div class="content-col1">
            <img :src="item.image" />
          </div>
          <div class="content-col2">{{ item.name }}</div>
          <div class="content-col3">{{ item.authority_zone }}</div>
          <div class="content-col4">{{ item.email }}</div>
          <div class="content-col5">{{ item.contact_address }}</div>
          <div class="content-col6">{{ item.date }}</div>
        </div>
      </div>
      <el-pagination
        style="padding: 15px 0"
        v-if="Number(total) !== 0"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="limit"
        :total="Number(total)"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
      <div v-if="jigouList.length===0" class="search-tips">
          <img src="../assets/hms/no-data.png">
          <div>暂无数据，请在上方设置查询条件后点击查询</div>
          <div style="height: 50px;"/>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import { Message } from "element-ui";
import { mapState } from "vuex";

export default {
  computed: mapState([]),
  components: {
  },
  data() {
    return {
      title: "招生服务机构",
      content:
        "招生服务机构作为企业合规官（CCO）培训项目的招生单位，是项目培训考试服务平台在全国范围内经过严格遴选产生的。每年，我们会根据机构的招生数量、服务质量等多个因素进行评估和调整，以确保我们能够为广大学员提供更完善、更优质的服务体系。",
      jigouList: [],
      total: 0,
      page: 1,
      limit: 10,
      name: '',
      headerList:[
                {name:'首页', href:'/'},
                {name:'授权机构', href:'/'},
            ]
    };
  },
  created() {
    // this.getDataFunc();
  },
  methods: {
    handleSizeChange(size) {
      this.limit = size;
      this.page = 1;
      this.getDataFunc();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getDataFunc();
    },
    searchHandle(){
      this.page = 1;
      this.getDataFunc()
    },
    async getDataFunc() {
      const res = await this.$http.get("/api/news/cooperatorPage", {
        limit: this.limit,
        page: this.page,
        type: 1,
        name: this.name
      });
      this.jigouList = res.data;
      this.total = res.total;
      if(res.data&&res.data.length === 0){
        Message.warning('没有查询到机构哦')
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.current-page-content {
  width: 1200px;
  box-sizing: border-box;
  margin-left: calc(50% - 600px);
  background-color: #fff;
}

.title-blo {
  width: 616px;
  position: relative;
  height: 90px;
  line-height: 90px;
  color: #3d3d3d;
  text-align: left;
  font-size: 28px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  border-bottom: 1px solid #b5b5b5;
  .title {
    position: relative;
  }
  .title::after {
    content: "";
    position: absolute;
    width: 118px;
    height: 8px;
    background-color: #164da0;
    left: 0px;
    bottom: -5px;
  }
}

.extrl-title {
  color: #3d3d3d;
  text-align: left;
  font-size: 30px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  height: 60px;
  line-height: 60px;
}
.title-p {
  width: 100%;
  color: #3d3d3d;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  font-family: "Microsoft YaHei";
  line-height: 36px;
  padding-bottom: 20px;
}

.line {
  width: 616px;
  position: relative;
  height: 1px;
  background-color: #b5b5b5;
}
.line::after {
  content: "";
  position: absolute;
  width: 118px;
  height: 8px;
  background-color: #164da0;
  left: 0px;
  bottom: -4px;
}
.jiazhi {
  line-height: 30px;
  width: 100%;
  padding: 20px 0 30px 0;
  color: #3d3d3d;
  font-size: 16px;
  font-weight: 400;
  font-family: "Microsoft YaHei";
}
.apply-btn {
  width: 207px;
  height: 46px;
  line-height: 46px;
  border-radius: 204px;
  opacity: 1;
  background: #164da0;
  color: #ffffff;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  cursor: pointer;
  margin: auto;
}

.common-row {
  display: flex;
  flex-direction: row;
  div {
    box-sizing: border-box;
  }
}
.en-header {
  margin-top: 27px;
  text-align: center;
  height: 52px;
  line-height: 52px;
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  font-family: "PingFang SC";
  div {
    border-right: 1px solid #b5b5b5;
    background-color: #164da0;
  }
  .header-col1 {
    width: 360px;
  }
  .header-col2 {
    width: 150px;
  }
  .header-col3 {
    width: 250px;
  }
  .header-col4 {
    width: 300px;
  }
  .header-col5 {
    width: 140px;
  }
}

.en-row {
  color: #3d3d3d;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  font-family: "Microsoft YaHei";
  align-items: center;
  div {
    border-right: 1px solid #b5b5b5;
    background-color: #fff;
    height: 90px;
    justify-content: center;
    text-align: center;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #b5b5b5;
  }
  .content-col1 {
    width: 150px;
    padding: 18px;
    border-left: 1px solid #b5b5b5;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .content-col2 {
    width: 210px;
  }
  .content-col3 {
    width: 150px;
  }
  .content-col4 {
    width: 250px;
  }
  .content-col5 {
    width: 300px;
  }
  .content-col6 {
    width: 140px;
  }
}

.tip {
  height: 38px;
  line-height: 38px;
  opacity: 1;
  background: #fef0f0;
  color: #b94a48;
  font-size: 14px;
  font-weight: 400;
  box-sizing: border-box;
  padding-left: 12px;
  margin-bottom: 20px;
  span {
    color: #ff0000;
  }
  i {
    color: #ff0000;
    padding-right: 10px;
  }
}
.banner-enscroll{
  width: 100%;
  height: 440px;
  position: relative;
  background: url(../assets/hms/banner-enscroll.png) no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  p{
    width: 1000px;
    margin: auto;
    color: #fff;
    font-size: 18px;
    margin-bottom: 20px;
    line-height: 30px;
  }
}
.search-input-blo{
  width: 1200px;
  margin: auto;
  background-color: #5891C4;
  height: 300px;
  box-sizing: border-box;
  padding-top: 50px;
  .title{
    text-align: center;
    color: #333333;
    font-size: 20px;
    font-weight: 900;
    margin-bottom: 10px;
  }
  .subtitle{
    text-align: center;
    color: #333333;
    font-size: 12px;
  }
  .desc-con{
    width: calc(100% - 200px);
    margin-left: 100px;
    margin-top: 40px;
    display: flex;
    align-items: center;
    .label{
      font-size: 20px;
      color:#164da0;
      font-weight: 700;
    }
    .s-input {
      width: calc(100% - 230px);
      margin-right: 25px;
      height: 47px;
      border-radius: 5px;
      ::v-deep .el-input__inner {
        height: 100% !important;
        border-radius: 0 !important;
      }
    }
    .search-btn {
      width: 100px;
      height: 47px;
      line-height: 47px;
      text-align: center;
      opacity: 1;
      background: #164da0;
      color: #ffffff;
      font-size: 18px;
      font-weight: 700;
      cursor: pointer;
    }
  }
}
.search-tips{
  width: 100%;
  padding: 80px 0 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #999999;
  font-size: 14px;
}
.search-tips img{
  width: 200px;
  height: auto;
  display: block;
  margin: 0 auto 12px auto;
}
</style>
